(ns frontend.view.modals.curtains.delete-option-curtain.events
  (:require [frontend.actions.entity :as entity-actions]
            [frontend.logging :as logging]))

(defn delete! [named-value modal-state close-modal! on-completed!]
  (swap! modal-state assoc :processing? true)
  (entity-actions/*->disable! (:db/id named-value)
                              (fn [_]
                                (swap! modal-state dissoc :processing?)
                                (on-completed! close-modal!))
                              (fn [err]
                                (swap! modal-state dissoc :processing?)
                                (swap! modal-state assoc :error (-> err ex-data :message))
                                (logging/error "Failed to delete option:" err))))
